import React from "react";
import { Radio } from "antd";
import { TranslateText } from "../../../../utils/translation";

const DiscountButton = ({ discountType, handleDiscountTypeChange }) => {
  return (
    <Radio.Group
      buttonStyle="outlined"
      className="flex flex-wrap gap-2"
      value={discountType}
      onChange={(e) => handleDiscountTypeChange(e.target.value)}
    >
      <Radio.Button value="percentage" className=" bg-[#F2F2F2]">
        
        <TranslateText textKey={"percentage"} namespace="pos" />

      </Radio.Button>
      <Radio.Button value="flat" className="bg-[#F2F2F2]">
        
        <TranslateText textKey={"flat"} namespace="pos" />

      </Radio.Button>
    </Radio.Group>
  );
};

export default DiscountButton;
